<div class="map-container row gy-5">
  <div class="map-filters col-3">
    <nav aria-label="breadcrumb" class="mt-8 mb-8">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active breadcrumb cursor" aria-current="page"
          (click)="redirectToDasboard()" (keypress)="redirectToDasboard()" tabindex="0">
          Dashboard
        </li>
      </ol>
    </nav>

    <h1 class="mat-h1">GeoXplore</h1>

    <div class="mt-4 mb-2">
      <mat-slide-toggle color="primary"
        [(ngModel)]="globalSearch"
        (change)="onSearchByLocationChange($event.checked)">
        Search Across the World
      </mat-slide-toggle>
    </div>

    <div class="geocoder-wrapper" [hidden]="globalSearch">
      <div id="geocoder"></div>
      <button mat-icon-button class="geocoder-arrow-button" aria-label="Submit location search" (click)="onArrowClick()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>


    @if (!globalSearch) {
      <mat-label class="mat-subtitle-2">Radius (1-99 miles)</mat-label>
    }
    @if (!globalSearch) {
      <mat-slider min="1" max="99" discrete color="primary"
        [disabled]="!hasValidLatLng">
        @if (!globalSearch) {
          <input matSliderThumb (input)="onSliderChange($event)"
            [value]="sliderValue"
            [disabled]="!hasValidLatLng"/>
        }
      </mat-slider>
    }

    <mat-form-field style="width: 100%;" appearance="outline">
      <mat-icon matPrefix>search</mat-icon>
      <input
        #soilCtrlAutocompleteInput
        type="text"
        placeholder="Select Soil Type"
        matInput
        [formControl]="soilCtrl"
        [matAutocomplete]="auto"
        (input)="filterSoilCategories()"
        (focus)="filterSoilCategories()"
        (blur)="validateSoilSelection()">
        <mat-autocomplete #auto="matAutocomplete" requireSelection (optionSelected)="onSoilSelected()">
          @if (!globalSearch) {
            <mat-option value="All" >All</mat-option>
          }
          @for (soil of filteredSoils; track soil) {
            <mat-option  [value]="soil" >
              {{ soil }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input
          #densityCtrlAutocompleteInput
          type="text"
          placeholder="Select Density"
          matInput
          [formControl]="densityCtrl"
          [matAutocomplete]="densityAuto"
          (input)="filterDensities()"
          (focus)="filterDensities()"
          (blur)="validateDensitySelection()"
          />
          <mat-autocomplete #densityAuto="matAutocomplete" requireSelection (optionSelected)="onDensitySelected()">
            <mat-option value="All">All</mat-option>
            @for (d of filteredDensities; track d) {
              <mat-option [value]="d">
                {{ d }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field style="width: 100%;" appearance="outline">
          <mat-icon matPrefix>search</mat-icon>
          <input
            #moistureCtrlAutocompleteInput
            type="text"
            placeholder="Select Moisture"
            matInput
            [formControl]="moistureCtrl"
            [matAutocomplete]="moistureAuto"
            (input)="filterMoistures()"
            (focus)="filterMoistures()"
            (blur)="validateMoistureSelection()"
            />
            <mat-autocomplete #moistureAuto="matAutocomplete" requireSelection (optionSelected)="onMoistureSelected()">
              <mat-option value="All">All</mat-option>
              @for (m of filteredMoistures; track m) {
                <mat-option [value]="m">
                  {{ m }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          @if (selectedMaterialType==='precast') {
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-label>Mix id</mat-label>
              <input matInput type="text" placeholder="Mix id" [formControl]="mixIdCtrl"
                autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false"/>
              </mat-form-field>
            }
          </div>

          <div id="map" class="match-parent col-9"></div>
        </div>
